import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
} from '@material-ui/core';
import { map } from 'lodash';
import TablePaginationActions from '../TablePaginationActions';
import { LIST_PAGE_COUNT } from '../../data/common';
import UserSubscriptionServiceTableRow from './UserSubscriptionServiceTableRow';

const UserSubscriptionServiceTable = (props) => {
  const { userSubscriptionServices, total, pageNum, setPageNum } = props;

  return (
    <TableContainer component={Box}>
      <Table aria-label="customized table">
        <TableHead>
          <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>會員</TableCell>
            <TableCell>訂閱項目</TableCell>
            <TableCell>訂閱價格</TableCell>
            <TableCell>訂閱時間</TableCell>
            <TableCell>開始日期</TableCell>
            <TableCell>結束日期</TableCell>
            <TableCell>付款方式</TableCell>
            <TableCell>訂單</TableCell>
            <TableCell>結帳人員</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {map(userSubscriptionServices, (userSubscriptionService) => (
            <UserSubscriptionServiceTableRow
              key={userSubscriptionService.id}
              userSubscriptionService={userSubscriptionService}
            />
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[LIST_PAGE_COUNT]}
              colSpan={10}
              count={total}
              rowsPerPage={LIST_PAGE_COUNT}
              page={pageNum - 1}
              SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
              }}
              onChangePage={(event, currentPage) => {
                setPageNum(currentPage + 1);
              }}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
};

export default UserSubscriptionServiceTable;
